export default "__VITE_ASSET__3e52399b__"